var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", { staticClass: "text-right" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-primary",
            attrs: { type: "button" },
            on: {
              click: function ($event) {
                return _vm.$refs.recipientForm.show()
              },
            },
          },
          [_vm._v("Add Recipient")]
        ),
      ]),
      !(_vm.userState || {}).create
        ? _c("top-table", {
            ref: "table",
            attrs: {
              "order-by": { column: "createdAt", ascending: 0 },
              headings: {
                createdAt: "Created",
                inActive: "InActive",
                generated: "IsGenerated",
              },
              "tab-filters": _vm.tabFilters,
              sortable: ["message", "recipient", "type"],
              hasClearFilters: true,
              columns: [
                "message",
                "recipient",
                "type",
                "description",
                "actions",
              ],
              requestFunction: _vm.requestFunction,
              url: "/notifications/recipients",
              overlap: true,
            },
            on: {
              loaded: function ($event) {
                return _vm.$emit("recipientsLoaded", [...$event.data])
              },
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "actions",
                  fn: function (props) {
                    return [
                      _c("div", { key: props.row._id, staticClass: "d-flex" }, [
                        _c(
                          "a",
                          {
                            staticClass: "mr-2",
                            on: {
                              click: function ($event) {
                                return _vm.openRecipientForm(props.row)
                              },
                            },
                          },
                          [_c("i", { staticClass: "far fa-edit" })]
                        ),
                        _c(
                          "a",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.deleteRecipientConfirmation(
                                  props.row
                                )
                              },
                            },
                          },
                          [_c("i", { staticClass: "far fa-trash" })]
                        ),
                      ]),
                    ]
                  },
                },
              ],
              null,
              false,
              4004927201
            ),
          })
        : _vm._e(),
      _c(
        "b-modal",
        {
          ref: "recipientForm",
          attrs: { "hide-footer": "", "hide-header": "" },
          on: { hide: _vm.closeModal },
        },
        [
          _c(
            "div",
            {
              staticClass: "d-flex justify-content-between align-items-center",
            },
            [_c("h3", [_vm._v("Add Notification ")])]
          ),
          _c(
            "div",
            [
              _c(
                "b-form-group",
                { attrs: { label: "Type" } },
                [
                  _c("b-form-select", {
                    attrs: { options: _vm.recipientTypesSelect },
                    model: {
                      value: _vm.currentRecipient.type,
                      callback: function ($$v) {
                        _vm.$set(_vm.currentRecipient, "type", $$v)
                      },
                      expression: "currentRecipient.type",
                    },
                  }),
                  _vm.$v.currentRecipient.type.$error
                    ? _c("span", { staticClass: "invalid-feedback d-block" }, [
                        _vm._v("Notification type is required"),
                      ])
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "b-form-group",
                { staticClass: "mb-0" },
                [
                  _vm._t("label", function () {
                    return [
                      _c("label", [_vm._v("Recipient")]),
                      _vm.currentRecipient.type === "Slack"
                        ? _c("i", {
                            directives: [
                              {
                                name: "b-popover",
                                rawName: "v-b-popover.hover",
                                value: {
                                  title: "Recipient",
                                  content:
                                    "Please note for Slack messages to private channels you will need to add the MPower Bot to the Slack channel. This can be found under #yourchannel > Info > More > Add Apps.",
                                },
                                expression:
                                  "{\n              title: 'Recipient',\n              content: 'Please note for Slack messages to private channels you will need to add the MPower Bot to the Slack channel. This can be found under #yourchannel > Info > More > Add Apps.'\n            }",
                                modifiers: { hover: true },
                              },
                            ],
                            staticClass:
                              "fas fa-question-circle text-light ml-2",
                          })
                        : _vm._e(),
                    ]
                  }),
                  _vm.currentRecipient.type === "Slack"
                    ? _c(
                        "div",
                        { staticClass: "mb-3" },
                        [
                          _c("multiselect", {
                            attrs: {
                              placeholder: "Select Option...",
                              "custom-label": _vm.slackRecipientsListLabel,
                              options: _vm.slackRecipientsList,
                              "track-by": "id",
                            },
                            model: {
                              value: _vm.slackRecipient,
                              callback: function ($$v) {
                                _vm.slackRecipient = $$v
                              },
                              expression: "slackRecipient",
                            },
                          }),
                          _vm.$v.slackRecipient?.$error
                            ? _c(
                                "span",
                                { staticClass: "invalid-feedback d-block" },
                                [_vm._v("Slack Recipient is required")]
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm.currentRecipient.type === "Email"
                    ? _c(
                        "div",
                        [
                          _c("validated-input", {
                            model: {
                              value: _vm.currentRecipient.recipient,
                              callback: function ($$v) {
                                _vm.$set(_vm.currentRecipient, "recipient", $$v)
                              },
                              expression: "currentRecipient.recipient",
                            },
                          }),
                          _vm.$v.currentRecipient.recipient?.$error
                            ? _c("div", [
                                _vm.$v.currentRecipient.recipient?.required &&
                                _vm.$v.currentRecipient.recipient?.$invalid
                                  ? _c(
                                      "span",
                                      {
                                        staticClass:
                                          "invalid-feedback d-block extra-space",
                                      },
                                      [_vm._v("Email value is invalid")]
                                    )
                                  : _vm._e(),
                                !_vm.$v.currentRecipient.recipient?.required
                                  ? _c(
                                      "span",
                                      {
                                        staticClass:
                                          "invalid-feedback d-block extra-space",
                                      },
                                      [_vm._v("Email field is required")]
                                    )
                                  : _vm._e(),
                              ])
                            : _vm._e(),
                        ],
                        1
                      )
                    : _c(
                        "div",
                        [
                          _c("validated-input", {
                            model: {
                              value: _vm.currentRecipient.recipient,
                              callback: function ($$v) {
                                _vm.$set(_vm.currentRecipient, "recipient", $$v)
                              },
                              expression: "currentRecipient.recipient",
                            },
                          }),
                          _vm.$v.currentRecipient.recipient?.$error
                            ? _c(
                                "span",
                                {
                                  staticClass:
                                    "invalid-feedback d-block extra-space",
                                },
                                [_vm._v("Recipient field is required")]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                ],
                2
              ),
              _c("validated-input", {
                attrs: { label: "Description", validate: { required: true } },
                model: {
                  value: _vm.currentRecipient.description,
                  callback: function ($$v) {
                    _vm.$set(_vm.currentRecipient, "description", $$v)
                  },
                  expression: "currentRecipient.description",
                },
              }),
              _c("validated-input", {
                attrs: {
                  type: "text-area",
                  label: "Message",
                  validate: { required: true },
                },
                model: {
                  value: _vm.currentRecipient.message,
                  callback: function ($$v) {
                    _vm.$set(_vm.currentRecipient, "message", $$v)
                  },
                  expression: "currentRecipient.message",
                },
              }),
              _c("div", { staticClass: "pt-3 small" }, [
                _c("div", { staticClass: "alert alert-info" }, [
                  _c("h6", { staticClass: "font-weight-normal" }, [
                    _vm._v("Allowed list of dynamic variables in message:"),
                  ]),
                  _c("b", [
                    _vm._v(
                      _vm._s(
                        [
                          "${orderId}",
                          "${orderTotal}",
                          "${paymentTotal}",
                          "${linkToOrder}",
                          "${notificationType}",
                          "${notificationCategory}",
                          "${notificationName}",
                          "${salesUserName}",
                          "${adminUserName}",
                          "${createdFollowUpUserName}",
                          "${customerName}",
                          "${storeName}",
                          "${followUpNotes}",
                          "${followUpDate}",
                          "${followUpType}",
                          "${friendlyPurchaseOrderDetailId}",
                          "${purchaseOrderStatus}",
                          "${customerCompany}",
                          _vm.isSuperAdmin && "${details}",
                          _vm.isSuperAdmin && "${distributorName}",
                          _vm.isSuperAdmin && "${distributorPlan}",
                        ]
                          .filter((e) => e)
                          .join(", ")
                      )
                    ),
                  ]),
                ]),
              ]),
              _c("div", { staticClass: "form-inline mt-3" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary",
                    attrs: { type: "button", disabled: _vm.pending },
                    on: { click: _vm.saveRecipient },
                  },
                  [
                    _vm.pending
                      ? _c("i", {
                          staticClass: "far fa-spinner-third fa-spin mr-2",
                        })
                      : _vm._e(),
                    _vm._v("Save\n        "),
                  ]
                ),
                _c(
                  "a",
                  { staticClass: "ml-3", on: { click: _vm.closeModal } },
                  [_vm._v("Cancel")]
                ),
              ]),
            ],
            1
          ),
        ]
      ),
      _c(
        "b-modal",
        {
          ref: "deleteRecipientConfirm",
          attrs: { title: "Delete Notification" },
          on: { ok: _vm.deleteRecipient },
        },
        [
          _vm.recipientToDelete
            ? _c("p", [
                _vm._v(
                  "\n      Are you sure you want to remove recipient\n      "
                ),
                _c("b", [_vm._v(_vm._s(_vm.recipientToDelete.recipient))]),
                _vm._v(" in "),
                _c("b", [_vm._v(_vm._s(_vm.recipientToDelete.type))]),
                _vm._v("?\n    "),
              ])
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }